<template>
  <div id="app">
    <div v-show="nonsupport" class="nonsupport-model">{{ nonsupportText }}</div>
    <!-- <xes-mall-navigator :fixed="true" :activeIndex="2"/> -->
    <navigator v-if="pageName !== 'course-detail'" :bs-env="10" :activeIndex="2"  :pageType="2" :debugger="isDebugger" />
    <navigator v-else :bs-env="10" :activeIndex="2" :pageType="2" :debugger="isDebugger" :hasLogin="userIsLogin" :customCartCount="cartCount" />
    <xes-mall-search :fixed="true" v-if="pageName === 'search'"/>
    <router-view class="router-view" ref="currentComponent"></router-view>

    <!-- <xes-mall-sidebar v-if="pageName !== 'course-detail'"/> -->
    <!-- <xes-mall-sidebar v-else :hasLogin="userIsLogin" :customCartCount="cartCount"/> -->

    <!-- <xes-mall-footer :feedBackUrl="feedBackUrl" /> -->
    <globalFooter :feedBackUrl="feedBackUrl" />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import browserType from '@/util/browserType'
import { localStorage } from '@/util/storage'
import getAccessToken from '@/util/requestToken'
import emitter from '@/mixins/emitter'
import globalTypes from '@/store/types'
import user from '@/store/user'
import { pagename } from '@/defines'

// import xesMallNavigator from '@/components/xesMallNavigator'
import navigator from '@/components/navigator'
// import { navigator } from '@xes/xueersi-mall-components'
import xesMallSearch from '@/components/xesMallSearch'
// import xesMallSidebar from '@/components/xesMallSidebar'
// import xesMallFooter from '@/components/xesMallFooter'
import { globalFooter } from "@xes/xueersi-mall-components";
import Cookies from "js-cookie";

console.log('process.env.NODE_ENV==', process.env.NODE_ENV);

export default {
  name: 'web-mall',
  componentName: 'webMall',
  components: {
    navigator,
    xesMallSearch,
    // xesMallSidebar,
    globalFooter,
  },
  mixins: [emitter],
  data() {
    return {
      pagename,
      isLogin: false,
      nonsupport: false,
      nonsupportText: '',
      // 埋点字段
      navLogArr: [],
      CustomerService: null,
      feedBackUrl: '',
      isDebugger: process.env.NODE_ENV === 'development' // process.env.NODE_ENV === 'local' false
    }
  },
  async mounted() {
    this.$store.commit(globalTypes.SET_PROTOCOL, window.location.protocol)
    this.checkBrowser()
    // 判断是否在app webview
    if (navigator && navigator.userAgent && navigator.userAgent.indexOf('jzh') !== -1) {
      localStorage.removeItem('userInfo')
    }
    this.$store.registerModule('user', user)
    const { isLogin, isLogout, isRegister } = this.$route.query
    if (isLogin) {
      // ====isLogin===
      await this.$store.dispatch(globalTypes.GET_TOKEN)
      this.setUserIsLogin(this.$store.state.user.isLogin)
      this.redirect('isLogin')
      return
    }
    if (isRegister) {
      // ====isRegister===
      await this.$store.dispatch(globalTypes.GET_TOKEN)
      this.setUserIsLogin(this.$store.state.user.isLogin)
      this.redirect('isRegister')
      return
    }
    if (isLogout) {
      // ====isLogout===
      this.$store.commit(globalTypes.LOGOUT)
      this.setUserIsLogin(this.$store.state.user.isLogin)
      this.redirect('isLogout')
      return
    }
    await getAccessToken({ store: this.$store }, true)
    this.setUserIsLogin(this.$store.state.user.isLogin)
    this.handleIframeUrl()
  },
  computed: {
    ...mapState({
      showConsultIFrame: state => state.showConsultIFrame,
      iFrameInit: state => state.iFrameInit,
      topAdv: state => state.topAdv,
      bottomAdv: state => state.bottomAdv,
      userIsLogin: state => state.userIsLogin,
      userInfo: state => state.user && state.user.userInfo,
      xAreaID: state => state.xAreaID,
      navigation: state => state.navigation,
      cartCount: state => state.NewCourseDetail && state.NewCourseDetail.cartCount
    }),
    pageName() {
      return this.$route.name
    }
  },
  watch: {
    pageName() {
      this.logAbout()
    },
    cartCount(val) {
      console.log('购物车数量', val)
    }
  },
  methods: {
    ...mapMutations({
      setLoginStatus: globalTypes.SET_USERISLOGIN
    }),
    handleIframeUrl() {
      const stuId = Cookies.get('stu_id')
      if (stuId) {
        this.feedBackUrl = `https://app.xueersi.com/servicepc/#/feedback?channelId=1&businessId=1&subBusinessId=1&roleId=4&userId=${stuId}&sourceFrom=xeswxpc`
      } else {
        this.feedBackUrl = 'https://app.xueersi.com/servicepc/#/feedback?channelId=1&businessId=1&subBusinessId=1&roleId=4&sourceFrom=xeswxpc'
      }
    },
    async setUserIsLogin(val) {
      this.setLoginStatus(val)
      if (val) {
        await this.$store.dispatch(globalTypes.GET_USER_INFO)
        // this.getNavInfo()
      }
      // this.$refs.globalNav.computedOnetoOne()
      this.$refs.currentComponent.$emit('LoginStatusCompleted', val)
    },
    deleteProp(oldObj, keyName) {
      const newObj = {}
      for (let key in oldObj) {
        if (key !== keyName) {
          newObj[key] = oldObj[key]
        }
      }
      return newObj
    },
    redirect(name) {
      const newQuery = this.deleteProp(this.$route.query, name)
      if (this.$route.path === '/index/') {
        window.location.replace('/index/')
        return
      }
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: newQuery
      })
      // this.getNavInfo()
    },
    checkBrowser() {
      const browser = browserType()
      // console.log('=====browser=====', browser)
      if (
        browser === 'IE6' ||
        browser === 'IE7' ||
        browser === 'IE8' ||
        browser === 'IE9' ||
        browser === '0'
      ) {
        this.nonsupport = true
        this.nonsupportText = '你的浏览器版本太低了,已经和时代脱轨了 :('
        window.alert('你的浏览器版本太低了,已经和时代脱轨了 :(')
        return
      }
      this.nonsupport = false
    },
    // async getNavInfo() {
    //   await this.$store.dispatch('GET_NAVIGATION')
    //   this.logAbout()
    // },
    logAbout() {
      this.navLogArr = []
      if (!(this.navigation && this.navigation.length > 0)) return
      if (!this.$XESLog) return
      this.formatLogData(this.navigation)
      // const logData = {
      //   eventid: 'navigationconfigurable',
      //   navinfo: JSON.stringify(this.navLogArr),
      //   pagename: pagename[this.pageName]
      // }
      // const XESLog = new this.$XESLog(logData)
      // XESLog.push(
      //   { eventname: 'exposure', target: this.$refs.globalNav.$el },
      //   this.$route
      // )
    },
    formatLogData(arr) {
      if (arr && arr.length === 0) return
      const len = arr.length
      for (let i = 0; i < len; i++) {
        const item = arr[i]
        const { id, name, order } = item
        this.navLogArr.push({
          navid: id,
          navname: name,
          order
        })
        if (item.child && item.child.length > 0) {
          this.formatLogData(item.child)
        }
      }
    }
  }
}
</script>
<style src="@/scss/index.scss" lang="scss"></style>
<style lang="scss">

.router-view {
  min-height: 1000px;
}
.nonsupport-model {
  position: fixed;
  margin: 0 auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #f5f5f5;
  /* z-index: 99; */
  padding-top: 40px;
  font-size: 26px;
  text-align: center;
}
button.vjs-play-control.vjs-control.vjs-button:focus {
  outline: none !important;
}
.video-js button.vjs-big-play-button {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  div.pip-small {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/App.vue